module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 132.7d54b5ae.png";